import { Icon } from "@iconify/react/dist/iconify.js";
import { NavLink, Link } from "react-router-dom";
import useSeccionesStore from "../store/seccionesStore";
import { useEffect } from 'react';

const Secciones = () => {
    const {secciones, iniciar} = useSeccionesStore();
    useEffect(() => {
        iniciar();
    }, [iniciar]);

    return (
        <div className="sidebar-menu-area">
          <ul className="sidebar-menu" id="sidebar-menu">
            {
              Array.isArray(secciones) && secciones.map((seccion) => (
                seccion.ES_SIDEBAR_SEC == 1 ?

                (<li key={seccion.ID_SEC}>
                  <NavLink to={`${seccion.RUTA_SEC}`} className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }>
                    <Icon icon={seccion.ICONO_SEC} className="menu-icon" />
                    <span>{seccion.NOMBRE_SEC}</span>
                  </NavLink>
                </li>)
                :
                (
                  <li key={seccion.ID_SEC} className="dropdown">
                    <Link to={JSON.parse(seccion.SUBSECCION)[0].RUTA_SEC} className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }>
                      <Icon icon={seccion.ICONO_SEC} className="menu-icon" />
                      <span>{seccion.NOMBRE_SEC}</span>
                    </Link>
                    <ul className="sidebar-submenu">
                      {
                        JSON.parse(seccion.SUBSECCION).map((subseccion) => (
                          <li key={subseccion.ID_SEC}>
                            <NavLink to={`${subseccion.RUTA_SEC}`} className={(navData) =>
                              navData.isActive ? "active-page" : ""
                            }>
                              <i className="ri-circle-fill circle-icon text-primary-600 w-auto" /> {subseccion.NOMBRE_SEC}
                            </NavLink>
                          </li>
                        ))

                      }
                    </ul>
                  </li>
                )
              ))
            }
          </ul>
        </div>
    );
}
 
export default Secciones;